import { formatDistanceToNow } from 'date-fns'

const timeAgo = (dateString: string) => `${formatDistanceToNow(new Date(dateString))} ago`

export const Dates = { timeAgo }
